module.exports = __webpack_public_path__ + "img/logo1.2393e9ce.png";